<top-bar></top-bar>

<router-outlet></router-outlet>
